import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseArticleGroups() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      faName: isEmpty(state.faName),
      enName: isEmpty(state.enName),
    };

    setter(errorState);
    if (errorState.faName || errorState.enName) {
      enqueueSnackbar("لطفا نام گروه را وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const GetArticleGroups = (bool, callback) => {
    MyAxios.get(`Admin_ArticleGroups?w=`, {
      headers: {
        IsPage: bool ? true : false,
        Conditions: JSON.stringify({ pageCondition: {} }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetAllAuthors = (callback) => {
    let myPC = {
      PageCount: 1,
    };
    MyAxios.get(`Admin_ArticleGroups?w=`, {
      headers: {
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetArticleGroupByID = (ArticleGroupID, callback) => {
    MyAxios.get(`Admin_ArticleGroups/${ArticleGroupID}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const AddArticleGroup = (Model, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    MyAxios.post(`Admin_ArticleGroups`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("افزودن گروه باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const UpdateArticleGroup = (Model, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    MyAxios.put(`Admin_ArticleGroups`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("ویرایش گروه باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const DeleteArticleGroup = (ArticleGroupID, callback) => {
    const data = new FormData();
    data.append("ArticleGroupID", ArticleGroupID);
    MyAxios.delete(`Admin_ArticleGroups`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("حذف گروه باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const GetAllAdvs = (callback) => {
    MyAxios.get(`Admin_ArticleGroups/adv`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };
  const GetArticleGroupAdvs = (ArticleID, callback) => {
    MyAxios.get(`Admin_ArticleGroups/adv/${ArticleID}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const EditArticleGroupAdv = (Model, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    MyAxios.post(`Admin_ArticleGroups/adv`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const AddArticleGroupAdv = (Model, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    MyAxios.post(`Admin_ArticleGroups/adv`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("افزودن تبلیغ مقاله باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const DeleteArticleGroupAdv = (ID, callback) => {
    const data = new FormData();
    data.append("ID", ID);
    MyAxios.delete(`Admin_ArticleGroups/adv`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("حذف تبلیغ مقاله باموفقیت انجام شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback(response.data.resault);
        }
      }
    );
  };

  const ResetCache = (id, callback) => {
    MyAxios.get(`Admin_ArticleGroups/ResetCache/${id}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("کش با موفقیت به‌روزرسانی شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  return {
    GetArticleGroups,
    GetArticleGroupByID,
    validate,
    AddArticleGroup,
    UpdateArticleGroup,
    DeleteArticleGroup,
    GetAllAdvs,
    GetArticleGroupAdvs,
    AddArticleGroupAdv,
    DeleteArticleGroupAdv,
    EditArticleGroupAdv,
    ResetCache,
  };
}
